import React from "react";

const IconLoader = ({ className = "h-4 w-4" }) => (
  <span className={`inline-block animate-pulse rounded-full bg-gray-200 ${className}`}></span>
);

export default IconLoader; 